import { i18n } from "@/i18n";

class DateFormatter {
  format(date, type, locale = null) {
    locale = locale ? locale : i18n.global.locale;
    const object = new Date(date);
    return i18n.global.d(object, type, locale);
  }

  isDate(value) {
    if (!value || typeof value === "boolean" || typeof value === "number") {
      return false;
    }

    if (typeof value === "string" && /^\d+$/.test(value.trim())) {
      return false;
    }

    const date = new Date(value);

    return !isNaN(date.getTime());
  }
}

export const dateFormatter = new DateFormatter();
